<script>
    import { convert } from "./ui";


    export let cards = [];
    export let name = ''

    export let show = ['traits', 'suits']

    function cardBreakdown(cards){
        let fullTraits = cards.flatMap(c => c.traits).sort();
        let fullSuits = cards.flatMap(c => c.suits).sort();
        let fullValues = cards.flatMap(c => c.values).sort();
        let fullStripes = cards.filter(c => c.stripe).map(c => c.stripe).sort();
        let traits = {};
        let suits = {};
        let values = {};
        let stripes = {};
        for(let t of fullTraits){
            if(!traits[t]) traits[t] = 0;
            traits[t]++;
        }
        for(let t of fullSuits){
            if(!suits[t]) suits[t] = 0;
            suits[t]++;
        }
        for(let t of fullValues){
            if(!values[t]) values[t] = 0;
            values[t]++;
        }
        for(let t of fullStripes){
            if(!stripes[t]) stripes[t] = 0;
            stripes[t]++;
        }
        return {traits, suits, values, stripes};
    }

let bd;
$: bd = cardBreakdown(cards);
    
</script>
<div class="breakdown">
    <div class="breakdown_header">{name}:</div>
    <div>
        Suits: 
        {#each Object.keys(bd.suits) as s, i}
            {bd.suits[s]}&nbsp;{@html convert(`[[${s}]]`, true)}{#if i < Object.keys(bd.suits).length - 1},{/if}
        {/each}
    </div>
    <div>
        Traits: 
        {#each Object.keys(bd.traits) as t, i}
            {bd.traits[t]}&nbsp;{@html convert(`[[${t}]]`, true)}{#if i < Object.keys(bd.traits).length - 1},{/if}
        {/each}
    </div>
    <div>
        Skills: 
        {#each Object.keys(bd.values) as t, i}
            {bd.values[t]}&nbsp;{@html convert(`[[${t}]]`, true)}{#if i < Object.keys(bd.values).length - 1},{/if}
        {/each}
    </div>
    <div>
        Focus icons: 
        {#each Object.keys(bd.stripes) as t, i}
            {bd.stripes[t]}&nbsp;{@html convert(`[[${t}]]`, true)}{#if i < Object.keys(bd.stripes).length - 1},{/if}
        {/each}
    </div>
</div>

<style>

.breakdown {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.breakdown_header {
    font-weight: bold;
}

</style>